import React from 'react';
import { useLanguage } from '../../assets/js/LanguageContext';
import PriceCard from '../common/PriceCard';
import SectionEyebrow from '../common/SectionEyebrow';
import { PLANS, planHighlights } from './plans';
import usePlanStart from './usePlanStart';

function PricingComponent() {
  const { t } = useLanguage();
  const startPlan = usePlanStart();

  return (
    <section className="section-band">
      <div className="section-band__inner">
        <div className="section-band__head">
          <h1 className="tp-sr-only">{t('pricing_title')}</h1>
          <div aria-hidden="true">
            <SectionEyebrow>{t('pricing_title')}</SectionEyebrow>
          </div>
          <p className="section-band__lead">{t('pricing_subtitle')}</p>
        </div>
        <div className="tp-price-grid">
          {PLANS.map((plan) => (
            <PriceCard
              key={plan.key}
              name={t(`pricing_${plan.key}`)}
              price={plan.price}
              period={t('pricing_month')}
              features={[
                t(`pricing_${plan.key}_diagnosticos`),
                t(`pricing_${plan.key}_participantes`),
                t(`pricing_${plan.key}_emotions`),
                ...planHighlights(plan.key).map((key) => t(key))
              ]}
              ctaText={t(`pricing_${plan.key}_btn`)}
              onCta={() => startPlan(plan.key)}
              featured={plan.featured}
              badge={t('pricing_most_popular')}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default PricingComponent;
